module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"search":"Suche({0})","sort_by":"Sortiere nach","btn_edit":"Bearbeiten","btn_delete":"Löschen"},"en":{"search":"Search({0})","sort_by":"Sort by","date":"Date","update_begin_date":"Update begin date","update_from":"Update from","update_till":"Update till","btn_edit":"Edit","btn_delete":"Delete"},"nl":{"btn_edit":"Bewerken","btn_delete":"Verwijder"}}')
  delete Component.options._Ctor
}
